module.exports = __webpack_public_path__ + "img/speaker-mute.e729a6f5.svg";